// Fox ESS CQ7 Package configurations — fully supplied + installed bundles.
// Each config pairs the CQ7 high-voltage modular battery with one of 5 Fox ESS hybrid inverters.

export const CQ7_INVERTERS = [
  { id: '5kw-1p', label: '5 kW 1P', short: '5 kW Single-Phase' },
  { id: '8kw-1p', label: '8 kW 1P', short: '8 kW Single-Phase' },
  { id: '10kw-1p', label: '10 kW 1P', short: '10 kW Single-Phase' },
  { id: '10kw-3p', label: '10 kW 3P', short: '10 kW Three-Phase' },
  { id: '15kw-3p', label: '15 kW 3P', short: '15 kW Three-Phase' },
];

// kWh capacities and BSTC (Battery STC) discount values from the user's pricing table.
// Prices below are CUSTOMER-FACING installed prices AFTER the BSTC rebate is applied.
export const CQ7_PACKAGES = [
  {
    slug: 'fox-ess-cq7-6.96',
    kwh: 6.96,
    config: '1 Master',
    bstcQty: 47,
    bstcDiscount: 1739,
    prices: { '5kw-1p': 5580, '8kw-1p': 6240, '10kw-1p': 6350, '10kw-3p': 6372, '15kw-3p': 6427 },
  },
  {
    slug: 'fox-ess-cq7-13.92',
    kwh: 13.92,
    config: '1 Master + 1 Slave',
    bstcQty: 94,
    bstcDiscount: 3478,
    prices: { '5kw-1p': 5574, '8kw-1p': 6234, '10kw-1p': 6344, '10kw-3p': 6366, '15kw-3p': 6421 },
  },
  {
    slug: 'fox-ess-cq7-20.88',
    kwh: 20.88,
    config: '1 Master + 2 Slaves',
    bstcQty: 132,
    bstcDiscount: 4884,
    prices: { '5kw-1p': 5900, '8kw-1p': 6560, '10kw-1p': 6670, '10kw-3p': 6692, '15kw-3p': 6747 },
  },
  {
    slug: 'fox-ess-cq7-27.84',
    kwh: 27.84,
    config: '1 Master + 3 Slaves',
    bstcQty: 161,
    bstcDiscount: 5957,
    prices: { '5kw-1p': 6560, '8kw-1p': 7220, '10kw-1p': 7330, '10kw-3p': 7352, '15kw-3p': 7407 },
  },
  {
    slug: 'fox-ess-cq7-34.80',
    kwh: 34.80,
    config: '1 Master + 4 Slaves',
    bstcQty: 171,
    bstcDiscount: 6327,
    prices: { '5kw-1p': 7922, '8kw-1p': 8582, '10kw-1p': 8692, '10kw-3p': 8714, '15kw-3p': 8769 },
  },
  {
    slug: 'fox-ess-cq7-41.76',
    kwh: 41.76,
    config: '1 Master + 5 Slaves',
    bstcQty: 178,
    bstcDiscount: 6586,
    prices: { '5kw-1p': 9396, '8kw-1p': 10056, '10kw-1p': 10166, '10kw-3p': 10188, '15kw-3p': 10243 },
  },
  {
    slug: 'fox-ess-cq7-48.72',
    kwh: 48.72,
    config: '1 Master + 6 Slaves',
    bstcQty: 185,
    bstcDiscount: 6845,
    prices: { '5kw-1p': 10869, '8kw-1p': 11529, '10kw-1p': 11639, '10kw-3p': 11661, '15kw-3p': 11716 },
  },
];

export const getCQ7Package = (slug) =>
  CQ7_PACKAGES.find((p) => p.slug === slug);

export const startingPrice = (pkg) =>
  Math.min(...Object.values(pkg.prices));

export const fmtAUD = (n) =>
  `$${Math.round(n).toLocaleString('en-AU')}`;
